import {
  Autocomplete,
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  Skeleton,
  TextField,
  Typography,
} from '@mui/material';
import customAxios from '../../../utils/customAxios';
import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';

import '../../../scss/Components/_modal.scss';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { GlobalVariables } from '../../../globalVar';

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { MuiTelInput } from 'mui-tel-input';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import moment from 'moment';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { getToast } from '../../../utils/toastConfig';
import CancelIcon from '@mui/icons-material/Cancel';

function ModalTUpdate(props) {
  const {
    phoneCountryStr,
    techBirthDateString,
    notesString,
    jobString,
    techEntryDateString,
  } = useTranslationHook();

  const weakPWErrorAlert = (missingRequirements) => {
    toast.dismiss();
    if (missingRequirements.length > 0) {
      toast.error(
        'La contraseña ingresada es débil. No cumple con los siguientes requisitos:',
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        },
      );

      missingRequirements.forEach((requirement) => {
        toast.info(`${requirement}`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPW] = useState('');
  const [verifyPassword, setVPW] = useState('');
  const [phone, setPhone] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [birthDate, setBirthDate] = useState(moment());
  const [entryDate, setEntryDate] = useState(moment());
  const [notes, setNotes] = useState('');
  const [job, setJob] = useState('');

  const [clients, setClients] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [roles, setRoles] = useState([]);
  const [roleId, setRoleId] = useState(null);

  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (props.show && props.techId) {
      fetchData();
    }
  }, [props.show, props.techId]);

  const fetchData = async () => {
    setIsFetching(true);
    try {
      const [clientsData, rolesData, techData] = await Promise.all([
        fetchClients(),
        fetchRoles(),
        fetchTech(),
      ]);

      setClients(clientsData);
      setRoles(rolesData);

      if (techData) {
        console.log(techData);
        setEmail(techData.tech_info.email);
        setName(techData.tech_info.name);
        setLastName(techData.last_names);
        setPhone(techData.tech_info.telefono);
        setCountryCode(techData.tech_info.countryCode);
        setBirthDate(moment(techData.tech_info.fechaNacimiento));
        setNotes(techData.tech_info.notes);
        setJob(techData.tech_info.job);
        setEntryDate(moment(techData.tech_info.entry_date));
        setRoleId(techData.tech_info.roles_id);

        const selected = clients.filter((client) =>
          techData.tech_info.clients.includes(client.id),
        );
        setSelectedClients(selected);
      }
    } catch (error) {
      console.error(error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error al obtener los datos',
      });
    } finally {
      setIsFetching(false);
    }
  };

  const fetchTech = async () => {
    const endpoint = `${GlobalVariables.getURL()}autofillTech/${props.techId}`;
    const response = await customAxios.get(endpoint, {
      headers: {
        Authorization: 'bearer ' + localStorage.getItem('token'),
      },
    });

    if (response.status !== 200) return null;

    return response.data;
  };

  const fetchClients = async () => {
    const endpoint = `${GlobalVariables.getURL()}listAutocompleteClients?targetUserId=${props.techId}?isTech=1`;
    const response = await customAxios.get(endpoint, {
      headers: {
        Authorization: 'bearer ' + localStorage.getItem('token'),
      },
    });

    if (response.status !== 200) return [];

    return response.data;
  };

  const fetchRoles = async () => {
    const endpoint = `${GlobalVariables.getURL()}roles/listTechRoles/`;
    const response = await customAxios.get(endpoint, {
      headers: {
        Authorization: 'bearer ' + localStorage.getItem('token'),
      },
    });

    if (response.status !== 200) return [];

    return response.data;
  };

  const resetFormFields = () => {
    setEmail('');
    setName('');
    setLastName('');
    setPW('');
    setVPW('');
    setPhone('');
    setCountryCode('');
    setBirthDate(moment());
    setNotes();
    setJob();
    setEntryDate(moment());
    setSelectedClients([]);
    setRoleId(null);
    setRoles([]);
  };

  function hide() {
    resetFormFields();
    props.onHide();
    toast.dismiss();
    getToast({
      status: 'success',
      title: 'Técnico actualizado exitosamente en la base de datos.',
    });
    props.getTechs();
  }

  function updateTech(event) {
    event.preventDefault();
    setIsLoading(true);
    const userClients = selectedClients.map((client) => client.id);
    if (password === verifyPassword) {
      const data = {
        name: name,
        last_names: lastName,
        email: email,
        password: password,
        telefono: phone,
        countryCode: countryCode,
        fechaNacimiento: birthDate.toISOString(),
        notes,
        roles_id: roleId,
        clients: userClients,
        job,
        entry_date: entryDate.toISOString(),
      };
      customAxios
        .patch(`${GlobalVariables.getURL()}updateTech/${props.techId}`, data, {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        })
        .then(
          (response) => {
            hide();
          },
          (error) => {
            console.log(error);
            if (error.response.data === 'Fecha invalida.') {
              toast.dismiss();
              getToast({
                status: 'error',
                title:
                  'La fecha de nacimiento no es válida. Vuelve a intentarlo.',
              });
            } else if (error.response.data.startsWith('Contraseña débil.')) {
              const requirements = [
                'Debe contener al menos una letra mayúscula.',
                'Debe contener al menos un número.',
                'Debe contener al menos un caracter especial (!@#$%^&*).',
                'Debe tener al menos 9 caracteres de longitud.',
              ];

              const missingRequirements = requirements.filter((requirement) =>
                error.response.data.includes(requirement),
              );

              weakPWErrorAlert(missingRequirements);
            } else if (error.response.data === 'Tecnico ya existe.') {
              toast.dismiss();
              getToast({
                status: 'error',
                title:
                  'Ya existe un técnico con esta información. Vuelve a intentarlo.',
              });
            } else {
              toast.dismiss();
              getToast({
                status: 'error',
                title: 'Error al actualizar técnico. Vuelve a intentarlo.',
              });
            }
          },
        )
        .finally(() => setIsLoading(false));
    } else {
      toast.dismiss();
      getToast({
        status: 'error',
        title: 'Contraseñas no coinciden. Vuelve a intentarlo.',
      });
      setIsLoading(false);
    }
  }

  return (
    <Modal
      onEntering={resetFormFields}
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
      onHide={() => {
        props.onHide();
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          Editar técnico
        </Modal.Title>
      </Modal.Header>
      <LocalizationProvider
        dateAdapter={AdapterMoment}
        adapterLocale={moment.locale()}
      >
        <Modal.Body>
          <form id='update-techs-form' onSubmit={updateTech}>
            <div className='row'>
              <div className='col-md-12'>
                {isFetching ? (
                  <Skeleton variant='rectangular' width='100%' height={56} />
                ) : (
                  <TextField
                    sx={{ width: '100%' }}
                    label='Correo electrónico'
                    type='email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    // required
                  />
                )}
              </div>
            </div>

            <br />

            <div className='row'>
              <div className='col-md-6'>
                {isFetching ? (
                  <Skeleton variant='rectangular' width='100%' height={56} />
                ) : (
                  <TextField
                    sx={{ width: '100%' }}
                    label='Nombre(s)'
                    type='text'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    // required
                  />
                )}
              </div>
              <div className='col-md-6'>
                {isFetching ? (
                  <Skeleton variant='rectangular' width='100%' height={56} />
                ) : (
                  <TextField
                    sx={{ width: '100%' }}
                    label='Apellido(s)'
                    type='text'
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    // required
                  />
                )}
              </div>
            </div>

            <br />

            <div className='row'>
              <div className='col-md-6'>
                {isFetching ? (
                  <Skeleton variant='rectangular' width='100%' height={56} />
                ) : (
                  <TextField
                    sx={{ width: '100%' }}
                    label={jobString}
                    type='text'
                    value={job}
                    onChange={(e) => setJob(e.target.value)}
                  />
                )}
              </div>
              <div className='col-md-6'>
                {isFetching ? (
                  <Skeleton variant='rectangular' width='100%' height={56} />
                ) : (
                  <DatePicker
                    sx={{ width: '100%' }}
                    label={techEntryDateString}
                    type='date'
                    value={entryDate}
                    onChange={(newDate) => {
                      setEntryDate(newDate);
                    }}
                  />
                )}
              </div>
            </div>

            <br />

            <div className='row'>
              <div className='col-md-6'>
                {isFetching ? (
                  <Skeleton variant='rectangular' width='100%' height={56} />
                ) : (
                  <TextField
                    sx={{ width: '100%' }}
                    label='Contraseña'
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPW(e.target.value)}
                    // required
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton
                            onClick={handleClickShowPassword}
                            edge='end'
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? (
                              <VisibilityOffOutlinedIcon />
                            ) : (
                              <VisibilityOutlinedIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              </div>
              <div className='col-md-6'>
                {isFetching ? (
                  <Skeleton variant='rectangular' width='100%' height={56} />
                ) : (
                  <TextField
                    sx={{ width: '100%' }}
                    label='Repetir contraseña'
                    type={showPassword ? 'text' : 'password'}
                    value={verifyPassword}
                    onChange={(e) => setVPW(e.target.value)}
                    // required
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton
                            onClick={handleClickShowPassword}
                            edge='end'
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? (
                              <VisibilityOffOutlinedIcon />
                            ) : (
                              <VisibilityOutlinedIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              </div>
            </div>

            <br />

            <div className='row'>
              <div className='col-md-12'>
                {isFetching ? (
                  <Skeleton variant='rectangular' width='100%' height={56} />
                ) : (
                  <Autocomplete
                    disabled={isLoading}
                    options={roles}
                    value={roles.find((r) => r.id === roleId) || null}
                    getOptionLabel={(role) => role.role_name || ''}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    onChange={(_, newValue) =>
                      setRoleId(newValue ? newValue.id : null)
                    }
                    renderInput={(params) => (
                      <TextField
                        name='role_name'
                        required
                        {...params}
                        label={'Rol'}
                        placeholder={`Rol...`}
                      />
                    )}
                  />
                )}
              </div>
            </div>

            <br />

            <div className='row'>
              <div className='col-md-12'>
                {isFetching ? (
                  <Skeleton variant='rectangular' width='100%' height={56} />
                ) : (
                  <Autocomplete
                    multiple
                    filterSelectedOptions
                    sx={{ width: '100%' }}
                    options={clients}
                    value={selectedClients}
                    getOptionLabel={(client) => client.business_name}
                    getOptionDisabled={(option) => option.can_select === 0} // Prevent selecting unassigned clients
                    // isOptionEqualToValue={(option, value) =>
                    //   option.id === value.id
                    // }
                    onChange={(_, newValue) => {
                      setSelectedClients(newValue ? newValue : null);
                    }}
                    renderTags={(tagValue, getTagProps) =>
                      tagValue.map((option, index) => {
                        const { onDelete, ...tagProps } = getTagProps({
                          index,
                        });

                        return (
                          <div
                            key={option.id}
                            style={{
                              position: 'relative',
                              display: 'inline-flex',
                              alignItems: 'center',
                            }}
                          >
                            <div
                              style={{
                                padding: '5px 10px',
                                borderRadius: '16px',
                                backgroundColor: '#ebebeb',
                                display: 'flex',
                                alignItems: 'center',
                                margin: '2px',
                                fontSize: '14px',
                              }}
                            >
                              {option.business_name}
                              {option.can_select === 1 ? (
                                <span
                                  // {...tagProps}
                                  onClick={onDelete}
                                  style={{
                                    marginLeft: '8px',
                                    cursor: 'pointer',
                                  }}
                                >
                                  <CancelIcon
                                    sx={{ color: 'gray', fontSize: '18px' }}
                                  />
                                </span>
                              ) : (
                                <span style={{ marginLeft: '8px' }}>
                                  <CancelIcon
                                    sx={{
                                      color: 'lightgray',
                                      fontSize: '18px',
                                    }}
                                  />
                                </span>
                              )}
                            </div>
                          </div>
                        );
                      })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={'Plazas'}
                        placeholder={'Plazas...'}
                        required={selectedClients.length === 0}
                      />
                    )}
                    isLoading={isFetching}
                  />
                )}
              </div>
            </div>

            <br />

            <div className='row'>
              <div className='col-md-6'>
                {isFetching ? (
                  <Skeleton variant='rectangular' width='100%' height={56} />
                ) : (
                  <MuiTelInput
                    sx={{ width: '100%' }}
                    label='Teléfono'
                    defaultCountry={countryCode}
                    langOfCountryName={phoneCountryStr}
                    value={phone}
                    onChange={(newPhone, info) => {
                      setPhone(newPhone);
                      setCountryCode(info.countryCode);
                    }}
                    forceCallingCode
                    disableFormatting
                    required
                  />
                )}
              </div>
              <div className='col-md-6'>
                {isFetching ? (
                  <Skeleton variant='rectangular' width='100%' height={56} />
                ) : (
                  <DatePicker
                    sx={{ width: '100%' }}
                    label={techBirthDateString}
                    type='date'
                    value={birthDate}
                    onChange={(newDate) => {
                      setBirthDate(newDate);
                    }}
                    slotProps={{
                      textField: {
                        required: true,
                      },
                    }}
                  />
                )}
              </div>
            </div>

            <br />

            <div className='row'>
              <div className='col-md-12'>
                {isFetching ? (
                  <Skeleton variant='rectangular' width='100%' height={56} />
                ) : (
                  <TextField
                    sx={{ width: '100%' }}
                    label={notesString}
                    type='text'
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                  />
                )}
              </div>
            </div>
          </form>
        </Modal.Body>
      </LocalizationProvider>
      <Modal.Footer>
        <Button
          type='submit'
          form='update-techs-form'
          className='update-modal-button'
          variant='contained'
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size='2rem' />
          ) : (
            <Typography>Guardar</Typography>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalTUpdate;
